define('gamedayLauncher/gamedayLauncher',['require','exports','module','jquery','./configs','pageMeta/pageMeta','deep-equal/index'],function(require, exports, module) {

	var $ = require('jquery');
	var configs = require('./configs');
	var pageMeta = require('pageMeta/pageMeta');

	var deepEqual = require('deep-equal/index');

	var urlsByGame = {};

	function createQueryString( gid, params ) {
		var str = '';
		Object.keys(params).forEach(function( param ) {
			str += '&'+param+'='+params[param];
		});
		if (pageMeta.isMilb) {
			str += '&sid='+( pageMeta.sid || 'milb' );
		}

		return gid+str;
	}

	function centeredPopup( url, name, config ) {
		var newWindowWidth = Math.min( screen.width, config.w );
		var newWindowHeight = Math.min( screen.height, config.h );

		var left = Math.round((screen.width-newWindowWidth)/2);
		var top = Math.round((screen.height-newWindowHeight)/2);

		window.open( url, name, 'width='+newWindowWidth+',height='+newWindowHeight+',left='+left+',top='+top+','+config.options);
	}

	exports.getUrl = function( gid, paramsOrMode ) {
		// If gid starts with 'gid_'
		if (gid.indexOf('gid_') === 0) {
			gid = gid.substr(4);
		}
		var params;
		if (typeof paramsOrMode === 'string') {
			params = {mode: paramsOrMode};
		} else {
			params = paramsOrMode || {};
		}

		if (!params.sport_code) {
			params.sport_code = gid.substring( 21, 24 );
		}

		if (urlsByGame[gid]) {
			// get the object with matching params, if it exists
			var launcherObject = urlsByGame[gid].filter(function( launcherObject ){
				return deepEqual( params, launcherObject.params );
			})[0];
			if (launcherObject) {
				return launcherObject.url;
			}
		}

		var version = configs.inferVersion( params, gid );
		var config = configs.versions[version];

		if (!config) {
			throw new Error('Tried open gameday version '+version+', which does not have a config.');
		}

		var queryString = createQueryString( gid, params );
		var url = config.url+queryString;

		// save this so we don't make two listeners for this url.
		if (!urlsByGame[gid]) {
			urlsByGame[gid] = [];
		}
		urlsByGame[gid].push({
			url: url,
			params: params
		});

		$(document.body).on('click', 'a[href$="'+url+'"]', function( event ) {
			if (event.isDefaultPrevented()) {
				return;
			}
			event.preventDefault();
			exports.launch( gid, params );
		});

		return url;
	};

	exports.launch = function( gid, params ) {

		var url = exports.getUrl( gid, params );
		var version = configs.inferVersion( params, gid );

		if (configs.shouldUsePopup(version, params)) {
			var windowName = configs.getWindowName( version, gid );
			centeredPopup( url, windowName, params );
		} else {
			window.location.href = url;
		}
	};

});
